import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68e94fc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-password" }
const _hoisted_2 = { class: "input-password__container" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "input-password__validations" }
const _hoisted_5 = ["value", "type", "required"]
const _hoisted_6 = {
  key: 1,
  class: "input-password__validations"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "input-password__requirements" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "requirements" }, "Sua senha deve seguir os requisitos abaixo:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleLabelClass($event.target.innerText, true))),
        class: _normalizeClass(['label', { focus: $setup.isInputFocused }, { required: $props.required }]),
        for: this.$attrs.id
      }, _toDisplayString($props.label), 11, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", _mergeProps(_ctx.$attrs, {
          value: $props.modelValue,
          class: "input",
          onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.onInput($event.target.value))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleLabelClass($event.target.value, true))),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleLabelClass($event.target.value, false))),
          type: $setup.showSpan(),
          required: $props.required
        }), null, 16, _hoisted_5),
        ($props.passwordVisibility)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.togglePassword())),
              class: _normalizeClass(["form__input__visibility", $setup.isPasswordVisible ? '' : 'notVisible'])
            }, null, 2))
          : _createCommentVNode("", true),
        ($props.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              ($setup.passwordWeak() && $setup.isInputFocused)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "senha fraca"))
                : _createCommentVNode("", true),
              ($setup.passwordIntermediate() && $setup.isInputFocused)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "senha boa"))
                : _createCommentVNode("", true),
              ($setup.passwordExcellent() && $setup.isInputFocused)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "senha forte"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      (!$setup.isCirculoTemplate())
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(['password-rule', { passed: $setup.specialCharacterValidationPassed }])
          }, "Caractere especial (!@#$%^&*).", 2))
        : _createCommentVNode("", true),
      (!$setup.isCirculoTemplate())
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(['password-rule', { passed: $setup.upperCaseValidationPassed }])
          }, "Letra maiúscula.", 2))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(['password-rule', { passed: $setup.lowerCaseValidationPassed }])
      }, "Letra minúscula.", 2),
      _createElementVNode("span", {
        class: _normalizeClass(['password-rule', { passed: $setup.numericCharacterValidationPassed }])
      }, "Pelo menos um número.", 2),
      _createElementVNode("span", {
        class: _normalizeClass(['password-rule', { passed: $setup.eightCharacterValidationPassed }])
      }, "No mínimo 8 caracteres.", 2),
      _createElementVNode("span", {
        class: _normalizeClass(['password-rule', { passed: $setup.noWhiteSpaceValidationPassed }])
      }, "Sem espaços em branco.", 2)
    ])
  ]))
}